const moviesDb = [
  {
    title: "The Girl with the Dragon Tattoo",
    id: 1,
    description:
      "A journalist is aided by a young female hacker in his search for the killer of a woman who has been dead for forty years.",
    director: "Niels Arden Oplev",
    cast: "Michael Nyqvist, Noomi Rapace, Ewa Fröling",
    trailer: "https://youtu.be/gBVwUWeB0CE",
    year: 2009,
    country: "Sweden",
    img:
      "https://m.media-amazon.com/images/M/MV5BMTc2Mjc0MDg3MV5BMl5BanBnXkFtZTcwMjUzMDkxMw@@._V1_SY1000_SX675_AL_.jpg",
  },
  {
    title: "The Girl Who Played with Fire",
    id: 2,
    description:
      "As computer hacker Lisbeth and journalist Mikael investigate a sex-trafficking ring, Lisbeth is accused of three murders, causing her to go on the run while Mikael works to clear her name.",
    director: "Daniel Alfredson",
    cast: "Noomi Rapace, Michael Nyqvist, Lena Endre ",
    trailer: "https://youtu.be/d2OHua_Ryzw",
    year: 2009,
    country: "Sweden",
    img:
      "https://m.media-amazon.com/images/M/MV5BMjI0MjIxMDIwNF5BMl5BanBnXkFtZTcwODk5MDc1Mw@@._V1_SY1000_CR0,0,674,1000_AL_.jpg",
  },
  {
    title: "The Girl Who Kicked the Hornet's Nest",
    id: 3,
    description:
      "Lisbeth is recovering in a hospital and awaiting trial for three murders when she is released. Mikael must prove her innocence, but Lisbeth must be willing to share the details of her sordid experiences with the court.",
    director: "Daniel Alfredson",
    cast: "Noomi Rapace, Michael Nyqvist, Lena Endre ",
    trailer: "https://youtu.be/vVGbPFdU96A",
    year: 2009,
    country: "Sweden",
    img:
      "https://m.media-amazon.com/images/M/MV5BMTk0NTY3NjMwOV5BMl5BanBnXkFtZTcwNTI1MjQwNA@@._V1_SY1000_SX675_AL_.jpg",
  },
  {
    title: "The Girl with the Dragon Tattoo",
    id: 4,
    description:
      "Journalist Mikael Blomkvist is aided in his search for a woman who has been missing for forty years by Lisbeth Salander, a young computer hacker.",
    director: "David Fincher",
    cast: "Daniel Craig, Rooney Mara, Christopher Plummer",
    trailer: "https://youtu.be/DqQe3OrsMKI",
    year: 2011,
    country: "USA",
    img:
      "https://m.media-amazon.com/images/M/MV5BMTczNDk4NTQ0OV5BMl5BanBnXkFtZTcwNDAxMDgxNw@@._V1_SY1000_CR0,0,674,1000_AL_.jpg",
  },
];

export default moviesDb;
